import React from 'react';

function DividerSection() {
  return (
    // Updated background to match the theme's light base color
    <div className="relative w-full h-10 md:h-20 overflow-hidden bg-slate-100">
      {/* Top section (implied by overall page background) */}

      {/* Blue Band - Left Diagonal Part */}
      <div className="absolute top-0 left-0 w-1/2 h-full bg-blue-500 transform -skew-y-3 origin-top-left"></div>

      {/* Blue Band - Right Diagonal Part */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-500 transform skew-y-3 origin-top-right"></div>
      
      {/* Bottom section (implied by overall page background) */}
    </div>
  );
}
// Note: The original component used non-standard transform classes like 'deg-negative-skew'. 
// I have left the standard Tailwind 'skew-y-3' classes as they handle the visual effect.

export default DividerSection;